<template>
  <div class="sign-in">
    <h2 class="title">象山水务集团 - 内部管理系统</h2>
    <div class="sign-room">
      <h3 class="title">用户登录</h3>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="图形验证码">
          <el-input
            class="captcha-input"
            v-model="form.captchabase64"
            placeholder="图形验证码"
          ></el-input>
          <img
            v-if="captchabase64"
            @click="getCaptchaBase64()"
            :src="captchabase64"
            class="captcha-base64"
          />
        </el-form-item>
        <el-form-item label="短信验证码">
          <el-input
            class="captcha-input"
            v-model="form.captcha"
            placeholder="短信验证码"
            @keyup.enter.native="signIn()"
          ></el-input>
          <el-button
            class="captcha-btn"
            @click="getCaptcha()"
            :type="captcha.btnType"
            :disabled="captcha.btnType === 'info'"
            plain
            >{{ captcha.text }}</el-button
          >
        </el-form-item>
        <div class="btn-room">
          <el-button class="btn-item" @click="signIn()" type="primary"
            >立即登录</el-button
          >
        </div>
      </el-form>
    </div>

    <el-dialog
      title="人机验证"
      :visible.sync="smsCaptcha.visible"
      width="360px"
      custom-class="sms-captcha-dialog"
      :close-on-click-modal="false"
    >
      <div class="sms-captcha-box">
        <el-input
          class="sms-captcha-input"
          v-model="smsCaptcha.code"
          placeholder="图形验证码"
          @keyup.enter.native="confirmSmsCaptcha()"
        ></el-input>
        <img
          v-if="smsCaptcha.image"
          class="sms-captcha-img"
          :src="smsCaptcha.image"
          title="点击刷新"
          @click="getSmsCaptchaImage(true)"
        />
        <span
          v-else
          class="sms-captcha-img sms-captcha-placeholder"
          @click="getSmsCaptchaImage(true)"
          >点击刷新</span
        >
      </div>
      <p class="sms-captcha-tip">看不清？点击图片刷新</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="smsCaptcha.visible = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary"
          :loading="smsCaptcha.sending"
          @click="confirmSmsCaptcha()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SignIn",
  data() {
    return {
      form: {
        mobile: "",
        captcha: ""
      },
      captcha: {
        text: "发送验证码",
        btnType: "primary",
        countDown: 60
      },
      captchabase64: "",
      smsCaptcha: {
        visible: false,
        image: "",
        captchaKey: "",
        code: "",
        sending: false
      }
    };
  },
  created() {
    document.querySelector("body").classList.add("auto-body");

    // 获取图形验证码
    this.getCaptchaBase64();
  },
  mounted() {
    this.getContactsList();
  },
  methods: {
    // 获取验证码
    getCaptchaBase64() {
      // 获取图形验证码
      ajax.get("/user/getCaptchaBase64", "", res => {
        this.captchabase64 = res.vo.image;
      });
    },

    // 获取通讯录列表
    getContactsList() {
      ajax.get("/dept/list", "", res => {
        this.$store.commit("set_organization", res.vo.array);
      });
    },
    // 登录系统
    signIn() {
      ajax.post(
        "/user/login",
        this.form,
        res => {
          this.$store.commit("set_userData", res.vo);
        },
        res => {
          this.$message.error(res.msg);
        }
      );
    },
    //验证手机，并给予提示
    verificationPhone() {
      //手机正则
      let phone = /^(1)\d{10}$/;
      if (!phone.test(this.form.mobile)) {
        return false;
      } else {
        return true;
      }
    },
    // 发送短信前的图形验证码
    getSmsCaptchaImage(clearCode) {
      ajax.get("/user/captcha/image", "", res => {
        this.smsCaptcha.image = res.vo.image;
        this.smsCaptcha.captchaKey = res.vo.captchaKey;
        if (clearCode) {
          this.smsCaptcha.code = "";
        }
      });
    },
    // 校验图形验证码并发送短信
    confirmSmsCaptcha() {
      var code = (this.smsCaptcha.code || "").replace(/^\s+|\s+$/g, "");
      if (!code) {
        this.$message.error("请输入图形验证码");
        return;
      }
      if (!this.smsCaptcha.captchaKey) {
        this.$message.error("图形验证码已失效，请刷新后重试");
        this.getSmsCaptchaImage(true);
        return;
      }
      if (this.smsCaptcha.sending) {
        return;
      }
      this.smsCaptcha.sending = true;
      ajax.get(
        "/user/captcha/send",
        {
          mobile: this.form.mobile,
          captchaKey: this.smsCaptcha.captchaKey,
          code: code
        },
        () => {
          this.smsCaptcha.sending = false;
          this.smsCaptcha.visible = false;
          this.captcha.btnType = "info";
          this.captcha.countDown = 60;
          this.captcha.text =
            "验证码发送成功（" + this.captcha.countDown + "s）";
          this.captchaCountDown();
        },
        () => {
          this.smsCaptcha.sending = false;
          this.getSmsCaptchaImage(true);
        }
      );
    },
    // 验证码倒计时
    captchaCountDown() {
      if (window.countDown) {
        clearInterval(window.countDown);
      }
      window.countDown = setInterval(() => {
        this.captcha.countDown--;
        this.captcha.text = "发送成功（" + this.captcha.countDown + "s）";
        if (this.captcha.countDown < 1) {
          this.captcha.btnType = "primary";
          this.captcha.text = "发送验证码";
          clearInterval(window.countDown);
        }
      }, 1000);
    },
    // 获取验证码
    getCaptcha() {
      if (!this.form.mobile) {
        this.$message.error("手机号码不能为空");
        return;
      }
      // 验证是否手机号
      if (!this.verificationPhone()) {
        this.$message.error(
          "您输入的并不是手机号，账号密码登录不需要获取验证码"
        );
        return;
      }
      if (this.captcha.btnType === "info") {
        return;
      }
      this.smsCaptcha.code = "";
      this.smsCaptcha.image = "";
      this.smsCaptcha.captchaKey = "";
      this.smsCaptcha.visible = true;
      this.getSmsCaptchaImage();
    }
  }
};
</script>

<style scoped>
.sms-captcha-box {
  overflow: hidden;
}

.sms-captcha-input {
  width: 150px;
}

.sms-captcha-img {
  width: 128px;
  height: 40px;
  margin-left: 8px;
  cursor: pointer;
  vertical-align: top;
}

.sms-captcha-placeholder {
  display: inline-block;
  line-height: 40px;
  text-align: center;
  color: #909399;
  font-size: 12px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.sms-captcha-tip {
  margin: 8px 0 0;
  color: #909399;
  font-size: 12px;
}

.sms-captcha-dialog {
  max-width: 92%;
}
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue